import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaArrowLeft, FaPen } from "react-icons/fa";
import { fetchQuestionById } from "../pages/services/questionService";
import QuestionView from "./questions/QuestionView";
import { plainText } from "./questions/questionUtils";
import "../styles/QuestionDetails.css";

const QuestionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchQuestionById(id)
      .then(setQuestion)
      .catch(() => setError("Could not load this question."))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="qd-page">
        <div className="qd-state"><div className="qd-spinner" /><p>Loading question…</p></div>
      </div>
    );
  }
  if (error || !question) {
    return (
      <div className="qd-page">
        <div className="qd-state">
          <p>{error || "Question not found."}</p>
          <button type="button" className="qd-btn qd-btn-ghost" onClick={() => navigate("/questions")}>Back to questions</button>
        </div>
      </div>
    );
  }

  const preview = plainText(question.question);

  return (
    <div className="qd-page">
      <header className="qd-head">
        <div className="qd-head-main">
          <button type="button" className="qd-back" onClick={() => navigate("/questions")}>
            <FaArrowLeft /> Questions
          </button>
          <h1 className="qd-title" title={preview}>{preview || "Untitled question"}</h1>
          <div className="qd-id">ID {question._id}</div>
        </div>
        <div className="qd-actions">
          <button type="button" className="qd-btn qd-btn-primary" onClick={() => navigate(`/questions/${id}/update`)}>
            <FaPen /> Edit question
          </button>
        </div>
      </header>
      <QuestionView question={question} />
    </div>
  );
};

export default QuestionDetails;
